export default __webpack_public_path__ + "static/media/information.0b9d6b2a.webp";